import { useEffect } from 'react';

// Keeps --header-height up to date across all routes
export default function LayoutVarsController() {
  useEffect(() => {
    let ro;
    let navRo;
    const apply = () => {
      try {
        const header = document.querySelector('#header') || document.querySelector('header');
        const h = header ? header.getBoundingClientRect().height : 0;
        document.documentElement.style.setProperty('--header-height', `${h}px`);

        const navCat = document.querySelector('.nav-category.active');
        const navH = navCat ? navCat.getBoundingClientRect().height : 0;
        document.documentElement.style.setProperty('--category-bar-height', `${navH}px`);
        const html = document.documentElement;
        if (navCat) html.classList.add('nav-category-fixed');
        else html.classList.remove('nav-category-fixed');
      } catch {}
    };
    apply();
    window.addEventListener('resize', apply);
    const header = document.querySelector('#header') || document.querySelector('header');
    if (header && 'ResizeObserver' in window) {
      ro = new ResizeObserver(apply);
      ro.observe(header);
    }
    const navCat = document.querySelector('.nav-category.active');
    if (navCat && 'ResizeObserver' in window) {
      navRo = new ResizeObserver(apply);
      navRo.observe(navCat);
    }
    return () => {
      window.removeEventListener('resize', apply);
      if (ro) ro.disconnect();
      if (navRo) navRo.disconnect();
    };
  }, []);
  return null;
}
